/**
 * Build a browser-openable URL for an attendance photo.
 * - Full http(s) URLs (e.g. R2) are returned as-is after normalizing common typos.
 * - Paths like /uploads/... are prefixed with the API base URL.
 */
export function resolveAttendancePhotoUrl(url, baseUrl = '') {
  if (!url || typeof url !== 'string') return '';
  const u = url.trim();
  if (!u) return '';
  // Malformed "https//host" or "http//host" (missing colon after scheme)
  if (u.startsWith('https//')) return `https://${u.slice(7)}`;
  if (u.startsWith('http//') && !u.startsWith('http://')) return `http://${u.slice(6)}`;
  if (u.startsWith('https://') || u.startsWith('http://')) return u;
  const base = (baseUrl || '').replace(/\/$/, '');
  if (u.startsWith('/')) return `${base}${u}`;
  return `${base}/${u}`;
}
